module.exports = __webpack_public_path__ + "files/SPIADI2022.9870cc95a37eeeb66261b2b8998fcb44.zip";